import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {workspaceValidator, type Workspace} from "@vesta/vos-types/modules/platformLevel/workspaces/domain/Workspace";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export type AdminWorkspace = Workspace & {storageDatabaseId: Uuid};

export const adminWorkspaceValidator = workspaceValidator.extend({
    storageDatabaseId: uuidZodValidator,
});
